module.exports = __webpack_public_path__ + "static/media/cashflow-down-btn.569b85cd.svg";